<template>
	<div>
		<div class="tw-text-3xl tw-font-bold">
			{{ $t('integrations.whatsapp-qr-authentication-title', { marketplace: marketplaceName }) }}
		</div>

		<AppForm @submit="onSubmit" class="tw-mt-2">
			<div class="tw-grid tw-grid-cols-2 tw-gap-x-3">
				<div class="tw-col-span-2 lg:tw-col-span-1">
					<AppInput
						:label="$t('integrations.session-name')"
						v-model="form.session_name"
						:rules="['required']"
						class="tw-w-full"
					/>
				</div>
				<div class="tw-col-span-2 lg:tw-col-span-1">
					<AppPhoneInput
						:label="$t('orders.phone-number')"
						v-model="form.phone_number"
						:rules="['required']"
						class="tw-w-full"
					/>
				</div>
			</div>
			<div class="tw-mt-5 tw-flex tw-items-center tw-gap-3">
				<AppButton
					:label="$t('integrations.confirm-data')"
					size="xl"
					class="tw-rounded-full"
					type="submit"
					:loading="submitLoading"
					endIcon="arrow-narrow-right"
				/>
			</div>
		</AppForm>
	</div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useLinkMarketplaceStore } from '../../../../stores/link-marketplace';
import { marketplaceStepStatusEnum } from '../../helper';
import { Marketplace } from '../../../../entities/marketplace';
import { Alert } from '@/v2/plugins/alert';
import AppPhoneInput from '@/v2/components/form/phone-input.vue';

const linkMarketplaceStore = useLinkMarketplaceStore();

const form = ref({
	session_name: '',
	phone_number: '',
});

const submitLoading = ref(
	linkMarketplaceStore.currentStepData.status === marketplaceStepStatusEnum.InProgress,
);
const isDone = ref(
	linkMarketplaceStore.currentStepData.status === marketplaceStepStatusEnum.Complete,
);

const marketplaceName = computed(() => {
	return linkMarketplaceStore.marketplace.name || '';
});

const onSubmit = async () => {
	submitLoading.value = true;
	isDone.value = false;
	try {
		await Marketplace.startWhatsAppQRAuthentication({
			...form.value,
			linked_marketplace_id: linkMarketplaceStore.linkedMarketplaceId,
		});
		nextStep();
	} catch (err) {
		Alert.error(err?.response?.data?.message?.error);
	} finally {
		submitLoading.value = false;
	}
};

const nextStepLoading = ref(false);
const nextStep = async () => {
	nextStepLoading.value = true;
	try {
		await Marketplace.finishWizardStep(linkMarketplaceStore.currentStepData.id);
		await linkMarketplaceStore.refetchSteps();
	} finally {
		nextStepLoading.value = false;
	}
};
</script>

<style lang="scss" scoped></style>
